import { render, staticRenderFns } from "./Video.vue?vue&type=template&id=98564ed2&scoped=true&"
import script from "./Video.vue?vue&type=script&lang=js&"
export * from "./Video.vue?vue&type=script&lang=js&"
import style0 from "./Video.vue?vue&type=style&index=0&lang=less&"
import style1 from "./Video.vue?vue&type=style&index=1&id=98564ed2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98564ed2",
  null
  
)

export default component.exports